var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInputError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#F2434A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00022 3.11111C8.49114 3.11111 8.88911 3.50908 8.88911 4V8.66667C8.88911 9.15759 8.49114 9.55556 8.00022 9.55556C7.5093 9.55556 7.11133 9.15759 7.11133 8.66667V4C7.11133 3.50908 7.5093 3.11111 8.00022 3.11111Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6667C8.55228 12.6667 9 12.2189 9 11.6667C9 11.1144 8.55228 10.6667 8 10.6667C7.44772 10.6667 7 11.1144 7 11.6667C7 12.2189 7.44772 12.6667 8 12.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputError);
export default __webpack_public_path__ + "static/media/icon-input_error.c173783f36ddd4fb3fca0e2007acad9d.svg";
export { ForwardRef as ReactComponent };